module.exports = __webpack_public_path__ + "img/SI5665493.5c17ed95.jpeg";